export const InitialsIconContainer = {
  textWrap: "nowrap",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
}
